import React from "react";
import { Col, Modal, Image, Table } from "react-bootstrap";
import ReactStars from "react-rating-stars-component";
import moment from "moment";

const ViewLikeDislikeReview = (props) => {
  return (
    <React.Fragment>
      <Modal
        show={props.showView}
        onHide={props.handleCloseView}
        centered
        size="lg"
      >
        <Modal.Header className="border-0 px-md-4" closeButton>
          <Modal.Title className="f20-700">
            View Like/Dislike for a Review
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="d-flex p-md-4">
            <div className="enIMG75">
              <Image
                //src={require("../../../../../assets/images/UserManagement/fhr7.png")}
                src={
                  props.review &&
                  props.review.restaurant_id &&
                  props.review.restaurant_id.logo_url
                }
                alt="restaurant logo"
                title="restaurant logo"
                fluid
                className="w-100 h-100"
              />
            </div>
            <div className="pl-3 row">
              <Col
                lg={10}
                xl={8}
                className="d-flex flex-column justify-content-between"
              >
                <div className="f24-500">
                  {props.review &&
                    props.review.restaurant_id &&
                    props.review.restaurant_id.restaurant_name}
                  ’s Review
                </div>
                <div className="f14-400">
                  {props.review &&
                    props.review.restaurant_id &&
                    props.review.restaurant_id.restaurant_address}
                </div>
              </Col>
            </div>
          </div>
          <div className="user-table-reusable-superadmin table-responsive">
            <Table className="HideShowTable enAuditLogTBL">
              <thead>
                <tr className="super_admin_all_users_table_head">
                  <th style={{ width: "20%" }} className="f12-700">
                    User Name
                  </th>
                  <th style={{ width: "20%" }} className="f12-700">
                    Ratings- Date & Time
                  </th>
                  <th style={{ width: "40%" }} className="f12-700">
                    Review / Comment
                  </th>
                  <th style={{ width: "20%" }} className="f12-700">
                    Service / Item
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="super_admin_all_users_table_body">
                  <td style={{ width: "20%" }}>
                    <div className="d-flex align-items-center justify-content-start">
                      <div className="d-flex flex-column align-items-center justify-content-center">
                        <div className="super-admin-suggestion-imageBoxOne enImage45 rounded-circle">
                          {props.review &&
                          props.review.user_id &&
                          props.review.user_id.profile_photo[0] ? (
                            <Image
                              fluid
                              //src={require("../../../../../assets/images/ActionImages/demoprofile.jpg")}
                              src={props.review.user_id.profile_photo[0]}
                              alt="Icon"
                            />
                          ) : (
                            <Image
                              fluid
                              src={require("../../../../../assets/images/ActionImages/demoprofile.jpg")}
                              //src={review.user_id.photos[0]}
                              alt="Icon"
                            />
                          )}
                        </div>
                        <div className="super-admin-suggestion-imageBoxTwo mt-2">
                          <div className="f12-400">
                            {" "}
                            {props.review &&
                              props.review.user_id &&
                              props.review.user_id.first_name}{" "}
                            {props.review &&
                              props.review.user_id &&
                              props.review.user_id.last_name}
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "20%" }}>
                    <div className="f12-400 mb-1">
                      {props.review && props.review.rating} Stars
                    </div>
                    <ReactStars
                      count={5}
                      value={props.review && props.review.rating}
                      edit={false}
                      size={22}
                      half={true}
                      emptyIcon={<i className="fa fa-star-o"></i>}
                      halfIcon={<i className="fa fa-star-half-alt"></i>}
                      fullIcon={<i className="fa fa-star"></i>}
                      color2={"#FDD400"}
                    />
                    <div className="f10-400 mt-1">
                      {moment(props.review && props.review.createdAt).format(
                        "Do MMM YYYY"
                      )}
                    </div>
                    <div className="f10-400 mt-1">
                      {moment(props.review && props.review.createdAt).format(
                        "hh:mm A"
                      )}
                    </div>
                  </td>
                  <td style={{ width: "40%" }}>
                    <div className="rating-review-table-body-sectiontwo ">
                      <span className="f12-400 enEllips3">
                        {props.review && props.review.review}
                      </span>
                      <div className="d-flex align-items-center pt-2">
                        <div className="d-flex align-items-center cursor">
                          <div>
                            <Image
                              fluid
                              alt="User Photo"
                              width="14px"
                              src={require("../../../../../assets/images/superadmin/like.svg")}
                            />
                          </div>
                          <div className="rating-review-table-body-usertextone">
                            <div className="f10-400 mt-1 mx-2">
                              {props.review &&
                                props.review.likes &&
                                props.review.likes.length}
                            </div>
                          </div>
                        </div>

                        <div className="d-flex align-items-center cursor">
                          <div>
                            <Image
                              fluid
                              alt="User Photo"
                              width="14px"
                              src={require("../../../../../assets/images/superadmin/disslike.svg")}
                            />
                          </div>
                          <div className="rating-review-table-body-usertextone">
                            <div className="f10-400 mt-1 mx-2">
                              {props.review &&
                                props.review.dislikes &&
                                props.review.dislikes.length}
                            </div>
                          </div>
                        </div>

                        <div className="d-flex align-items-center cursor">
                          <div>
                            <Image
                              fluid
                              alt="User Photo"
                              width="14px"
                              src={require("../../../../../assets/images/superadmin/chat.svg")}
                            />
                          </div>
                          <div className="rating-review-table-body-usertextone">
                            <div className="f10-400 mt-1 mx-2">
                              {props.review && props.review.comment.length}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "20%" }}>
                    {props.review &&
                    props.review.diner_id &&
                    props.review.diner_id.service_type ? (
                      <div className="d-flex align-items-center">
                        <div className="image-box-new mr-2">
                          <Image
                            fluid
                            src={require("../../../../../assets/images/seatingImages/reservationBlack.png")}
                          />
                        </div>
                        <div>
                          <div className="f12-500">
                            {props.review.diner_id.service_type}
                          </div>
                          <span className="f10-400">
                            {props.review.diner_id._id}
                          </span>
                        </div>
                      </div>
                    ) : (
                      <> </>
                    )}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
          <div className="f18-500 px-4">Comments for Review</div>
          <div className="user-table-reusable-superadmin table-responsive">
            <Table className="HideShowTable enAuditLogTBL w-100">
              <thead>
                <tr className="super_admin_all_users_table_head">
                  <th
                    style={{ width: "20%" }}
                    className="f12-700 enBgGrayLIght"
                  >
                    Date
                  </th>
                  <th
                    style={{ width: "40%" }}
                    className="f12-700 enBgGrayLIght"
                  >
                    Comments
                  </th>
                  <th
                    style={{ width: "25%" }}
                    className="f12-700 enBgGrayLIght"
                  >
                    User ID
                  </th>
                  <th
                    style={{ width: "15%", textAlign: "center" }}
                    className="f12-700 enBgGrayLIght"
                  >
                    Like/Dislike
                  </th>
                </tr>
              </thead>
              <tbody>
                {props.review &&
                  props.review.comment.map((comment, index) => (
                    <tr className="border-bottom" key={index}>
                      <td style={{ width: "20%" }}>
                        <div className="f15-400">
                          {" "}
                          {moment(comment && comment.createdAt).format(
                            "Do MMMM YYYY,"
                          )}
                        </div>
                        <div className="f15-400">
                          {moment(comment && comment.createdAt).format("LT")}
                        </div>
                      </td>
                      <td style={{ width: "40%" }}>
                        <div className="f14-400">{comment.message}</div>
                      </td>
                      <td style={{ width: "25%" }}>
                        <div className="f15-400">
                          {comment.user_details.first_name}
                          {comment.user_details.last_name}
                        </div>
                        <div className="f11-400">
                          {" "}
                          #{comment.user_details._id}
                        </div>
                      </td>
                      <td style={{ width: "15%", textAlign: "center" }}>
                        <div className="d-flex align-items-center pt-2">
                          <div className="d-flex align-items-center cursor">
                            <div>
                              <Image
                                fluid
                                alt="User Photo"
                                width="14px"
                                src={require("../../../../../assets/images/superadmin/like.svg")}
                              />
                            </div>
                            <div className="rating-review-table-body-usertextone">
                              <div className="f10-400 mt-1 mx-2">
                                {comment.like.length}
                              </div>
                            </div>
                          </div>
                          <div className="d-flex align-items-center cursor">
                            <div>
                              <Image
                                fluid
                                alt="User Photo"
                                width="14px"
                                src={require("../../../../../assets/images/superadmin/disslike.svg")}
                              />
                            </div>
                            <div className="rating-review-table-body-usertextone">
                              <div className="f10-400 mt-1 mx-2">
                                {comment.dislike.length}
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}

                {/* <tr className="border-bottom">
                  <td style={{ width: "20%" }}>
                    <div className="f15-400">13th August, 2019</div>
                    <div className="f15-400">06:30 PM</div>
                  </td>
                  <td style={{ width: "40%" }}>
                    <div className="f14-400">
                      Seating status changed from not seated to seated
                    </div>
                  </td>
                  <td style={{ width: "25%" }}>
                    <div className="f15-400">Ramakrishna Reddy</div>
                    <div className="f11-400">12322323232</div>
                  </td>
                  <td style={{ width: "15%", textAlign: "center" }}>
                    <Image
                      fluid
                      alt="User Photo"
                      width="14px"
                      src={require("../../../../../assets/images/superadmin/disslike.svg")}
                    />
                  </td>
                </tr> */}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
export default ViewLikeDislikeReview;
